import { MotionConfig } from "framer-motion";
import Showcase from "@/pages/Showcase";

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Showcase />
    </MotionConfig>
  );
}
